import { IConfig, IGeneralConfig, IPatternConfig } from './interfaces/patternsConfig.interface';

export class PatternsConfig {
  constructor(private configObj: IConfig) {}

  get(): IPatternConfig[] {
    return Object.values(this.configObj.patterns);
  }

  getGeneral(): IGeneralConfig
  getGeneral<ConfigKey extends keyof IGeneralConfig>(configName: ConfigKey): IGeneralConfig[ConfigKey]
  getGeneral(configName?: keyof IGeneralConfig): any {
    return configName
      ? this.configObj.general[configName]
      : this.configObj.general as IGeneralConfig;
  }
}
